module.exports = __webpack_public_path__ + "img/simple_logo.531c2f71.svg";